import { constructParams } from "../utils/data";
import auth from "../utils/auth";

export const fetchUsers = async () => {
  const result = await (await auth.fetch(`/api/user`)).json();
  return result?.data;
};

export const fetchUsersOfOperator = async (operatorId) => {
  const result = await (await auth.fetch(`/api/user/${operatorId}`)).json();
  return result?.data;
};

export const addUser = async (user) => {
  const response = await auth.fetch(`/api/user`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(user),
  });
  if (response) {
    const result = await response.json();
    return result.data;
  }
  return [];
};

export const updateUser = async (user) => {
  const response = await auth.fetch(`/api/user`, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(user),
  });
  if (response) {
    const result = await response.json();
    return result.data;
  }
  return [];
};
